// Vibes.js
import React, { useState, useEffect } from "react";
import { Box, Container, Flex, HStack, Progress, Text } from "@chakra-ui/react";
import { Story, PubEventCard } from "@zillout/shared-components";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowForwardIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CloseIcon,
} from "@chakra-ui/icons";

const Vibes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  const storiesData = data && data.vibes?.vibes ? data.vibes.vibes : [];
  const defaultIdx = data && data.vibes?.defaultIdx ? data.vibes.defaultIdx : 0;

  const [showMore, setShowMore] = useState(false);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(defaultIdx);
  const [progressValues, setProgressValues] = useState(
    new Array(storiesData.length).fill(0)
  );

  const handleNextStory = () => {
    if (currentStoryIndex < storiesData.length - 1) {
      setCurrentStoryIndex(currentStoryIndex + 1);
    } else {
      goBack();
    }
  };

  const handlePrevStory = () => {
    if (currentStoryIndex > 0) {
      setCurrentStoryIndex(currentStoryIndex - 1);
    } else {
      goBack();
    }
  };

  const goBack = () => {
    if (!window.history || window.history.length <= 1) {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      w={"100vw"}
      h={"100dvh"}
      background="#111111"
      overflow={"hidden"}
      position={"relative"}
    >
      <HStack w={"100%"} mt={0}>
        {storiesData.map((story: string, index: number) => (
          <Progress
            key={index}
            value={
              index < currentStoryIndex
                ? 100
                : index === currentStoryIndex
                  ? progressValues[currentStoryIndex]
                  : 0
            }
            size="xs"
            colorScheme="purple"
            position="absolute"
            top="4"
            left={
              index === 0 ? 2 : `calc(${index * (100 / storiesData.length)}%)`
            }
            width={`calc(${90 / storiesData.length}% - 5px)`}
            h={"2px"}
            borderRadius={4}
            zIndex={2}
          />
        ))}
      </HStack>
      <Box position="relative">
        <CloseIcon
          position="absolute"
          top={10}
          right={5}
          w={5}
          h={5}
          color="whiteAlpha.700"
          zIndex={20}
          onClick={() => goBack()}
          cursor={"pointer"}
        />
        <Story
          index={currentStoryIndex}
          total={storiesData.length}
          story={storiesData[currentStoryIndex]}
          onNext={handleNextStory}
          onPrev={handlePrevStory}
          onUpdateProgress={(value) => {
            setProgressValues((prevValues) =>
              prevValues.map((prevValue, index) =>
                index === currentStoryIndex ? value : prevValue
              )
            );
          }}
        />
      </Box>

      {data && (data.eventId || data.itemId) ? (
        <Box position="absolute" w="100%" bottom={0}>
          <Flex
            w="100%"
            position={"relative"}
            borderTopRadius={16}
            bg="#1E1E1E"
            p={4}
            px={8}
            h={showMore ? "340px" : "140px"}
            overflow={"hidden"}
            transition="height 0.4s ease-out"
            flexDir={"column"}
          >
            {data && data.eventId ? (
              <Flex w="100%" alignItems="center" justifyContent="center">
                {!showMore ? (
                  <ChevronUpIcon
                    color="#A383FF"
                    alignSelf="center"
                    mb={6}
                    boxSize={6}
                    onClick={() => setShowMore(true)}
                  />
                ) : (
                  <ChevronDownIcon
                    color="#A383FF"
                    alignSelf="center"
                    mb={6}
                    boxSize={6}
                    onClick={() => setShowMore(false)}
                  />
                )}
              </Flex>
            ) : null}

            {data?.itemId ? (
              <Flex
                w="100%"
                alignItems="flex-start"
                onClick={() => navigate(`/pub/detail/${data?.itemId}`)}
                mt={data && data.eventId ? 0 : 2}
              >
                <Flex flexDir="column">
                  <Text color="white" fontWeight={600} fontSize="lg">
                    {data?.name}
                  </Text>
                  <Flex color="#828282">
                    <Text fontWeight={600} fontSize="10px">
                      {data?.pubType.toUpperCase()}
                    </Text>
                    <Text fontSize="12px" fontWeight={700} mx={2}>
                      &#x2022;
                    </Text>
                    <Text fontWeight={600} fontSize="10px">
                      {data?.shortAddress}
                    </Text>
                  </Flex>
                </Flex>
                <ArrowForwardIcon
                  color="#A383FF"
                  ml="auto"
                  mt={1}
                  boxSize={6}
                />
              </Flex>
            ) : null}

            {data && data.eventId ? (
              <Box mt={10} w="100%">
                <PubEventCard event={data} bg="#161616" />
              </Box>
            ) : null}
          </Flex>
        </Box>
      ) : null}
    </Box>
  );
};

export default Vibes;
